'use strict';

var angular = require('angular');
var dependencies = [];
module.exports = angular.module('AVRO.Common.Configuration.LandingPageConstants', dependencies).constant('LandingPageConstants', require('../constants/LandingPageConstants'));